import React from 'react';
import { Box, Typography, Link, Container } from '@mui/material';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                py: 3,
                px: 2,
                mt: 'auto',
                backgroundColor: (theme) => theme.palette.grey[100],
                borderTop: '1px solid',
                borderColor: 'divider'
            }}
        >
            <Container>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        textAlign: { xs: 'center', sm: 'left' }
                    }}
                >
                    <Typography variant="body2" color="text.secondary" sx={{ mb: { xs: 1, sm: 0 } }}>
                        © Copyrights {currentYear} by Vector India
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: { xs: 1, sm: 2 }
                        }}
                    >
                        <Link
                            href="https://www.vectorindia.org/terms-and-conditions.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            color="inherit"
                            variant="body2"
                            underline="hover"
                        >
                            Terms & Conditions
                        </Link>
                        <Link
                            href="https://www.vectorindia.org/privacy-policy.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            color="inherit"
                            variant="body2"
                            underline="hover"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            href="https://www.vectorindia.org/refund-and-cancellation-policy.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            color="inherit"
                            variant="body2"
                            underline="hover"
                        >
                            Refund and Cancellation Policy
                        </Link>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer; 